// Copyright (c) 2022 Siemens

/**
 * @module js/DesDownloadService
 */
import _ from 'lodash';
import modelPropertySvc from 'js/modelPropertyService';
import eventBus from 'js/eventBus';
import messagingSvc from 'js/messagingService';




const True = "True";
const False = "False";

export const downloadAs = async (url, name) =>
                {
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = name;
                    a.click();
                };


export const downloadFiles = function (vmo, i18n) {
    const { data, dispatch } = vmo;
    const urlArray = data.listOfValues;
    let messagearray = 0;

    if (urlArray && urlArray.length) {
        urlArray.forEach((url, index) => {
            if (url.uiValue === True) {
                messagearray = messagearray + 1;
                downloadFile(vmo, url, index);
            }
        })

        if (messagearray === 1) {
            messagingSvc.showInfo(i18n.downloadMessage);
        } else if (messagearray > 1) {
            messagingSvc.showInfo(i18n.downloadMessageForMultipleFiles);
        }
    }

    data.checkBoxSelectionArray = [];
    data.selectedCheckBoxToChips = [];
    dispatch({ path: 'data', value: { ...data } });
};

function downloadFile(vmo, url, index) {
    const { data } = vmo;

   // If in Chrome or Safari - download via virtual link click
   const isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
   const isSafari = navigator.userAgent.toLowerCase().indexOf('safari') > -1;
   // Get attachment name
   const params = url.value.split('//')[1].split('/');
   const attachmentName = params[params.length - 1];
    if (params && params.length && ((isChrome || isSafari) || !(isChrome && isSafari))) {
        downloadAs(url.value, attachmentName);
    }

   data.listOfValues[index].dbValue = false;
   data.listOfValues[index].uiValue = false;
}

/**
 * Get Filter data
 * @param {Object} catalogPartAttachement the catalogPartAttachement
 * @param {Object} vmo the viewModelObject
 * @param {Object} filterStr the filterString
 * @return {Object} the checkBox list for rendering
 */
export const getListOfCheckBox = function (catalogPartAttachement, filterStr, vmo) {
    const { data, dispatch } = vmo;
    const listOfValuestoRe = [];
    let filteredAttachment = [];
    const filterString = filterStr || data.searchBox.dbValue;
    // check for attachment from resolver
    if (data.catalogPartAttachments && data.catalogPartAttachments.length) {
        if (filterString) {
            filteredAttachment = data.catalogPartAttachments.filter((PartAttachment => PartAttachment.displayName.toLowerCase().includes(filterString.toLowerCase())));
        } else {
            filteredAttachment = data.catalogPartAttachments;
        }

        // check for filterResults Found
        if (filteredAttachment && filteredAttachment.length) {
            _.forEach(filteredAttachment, function (propAttrHolder) {
                const vmProp = modelPropertySvc.createViewModelProperty(propAttrHolder);
                vmProp.value = propAttrHolder.propInternalValue;
                listOfValuestoRe.push(vmProp);
            });
            data.isResult = true;
            data.noResultFound = false;
            data.checkBoxSelectionArray = [];
            data.selectedCheckBoxToChips = [];
            dispatch({ path: 'data', value: { ...data } });
            return listOfValuestoRe;
        } else {
            data.noResultFound = true;
            dispatch({ path: 'data.noResultFound', value: { ...data } });
        }
    }
    return listOfValuestoRe;
};

export const updateSelectionCheckBox = function (vmo) {
    const { data, dispatch } = vmo;
    let updatedCheckBoxArray = data.checkBoxSelectionArray;
    for (const value in data.listOfValues) {
        // push the first selected value in checkBoxArray
        if (data.listOfValues[value].uiValue === True && data.checkBoxSelectionArray.length === 0) {
            data.checkBoxSelectionArray.push(data.listOfValues[value]);
            break;
        } else {
            updatedCheckBoxArray = isValuePresentCheckBoxArray(data.listOfValues[value], updatedCheckBoxArray);
        }
        data.checkBoxSelectionArray = updatedCheckBoxArray;
    }
    data.selectedCheckBoxToChips = createPropertyForChips(updatedCheckBoxArray);
    eventBus.publish('selectedfileAttachmentDataProvider.reset');
    dispatch({ path: 'data', value: { ...data } });
};

/**
 * Get updatedCheckBox selection array
 *
 * @param {Object} value value of Fileattachment
 * @param {Object} checkBoxSelectionArray existing array of selection
 * @return {Object} the updated check box array data
 */
const isValuePresentCheckBoxArray = (value, checkBoxSelectionArray) => {
    const updatedcheckBoxSelectionArray = checkBoxSelectionArray;
    if (value.uiValue === True) {
        const found = updatedcheckBoxSelectionArray.some(checkBoxItem => checkBoxItem.propertyDisplayName === value.propertyDisplayName || value.labelDisplayName
            && checkBoxItem.uiValue === True);
        if (!found) {
            // push the value which was not present in array
            updatedcheckBoxSelectionArray.push(value);
        }
    } else {
        // Find the index of the object want to remove
        if (updatedcheckBoxSelectionArray.some(checkBoxItem => checkBoxItem.propertyDisplayName === value.propertyDisplayName)) {
            const index = updatedcheckBoxSelectionArray.findIndex(checkBoxItem => checkBoxItem.propertyDisplayName === value.propertyDisplayName);
            if (index !== -1) {
                updatedcheckBoxSelectionArray.splice(index, 1);
            }
        }
    }

    // }
    return updatedcheckBoxSelectionArray;
}

const createPropertyForChips = (selectedCheckBoxs) => {
    const listOfChips = [];
    _.forEach(selectedCheckBoxs, function (checkBoxProp) {
        const vmProp = {
            iconId: "miscAssigned",
            uiIconId: "miscRemoveBreadcrumb",
            chipType: "BUTTON",
            labelDisplayName: checkBoxProp.propertyDisplayName,
            // this extra variable for just ensuring the chip is available
            uiValue: "True"
        }
        listOfChips.push(vmProp);
    });
    return listOfChips;
}

// remove the filters on close action
export const removeSelectedChip = (chipArray, chipToRemove, vmo) => {
    if (chipToRemove) {
        const { data, dispatch } = vmo;
        const objToUpdate = data.listOfValues.find(value => value.propertyDisplayName === chipToRemove.labelDisplayName);
        if (objToUpdate) {
            objToUpdate.uiValue = False;
            objToUpdate.dbValue = false;
        }

        //slice the unselected attachment while closing the chips
        if (data.checkBoxSelectionArray.some(checkBoxItem => checkBoxItem.propertyDisplayName === chipToRemove.labelDisplayName)) {
            const index = data.checkBoxSelectionArray.findIndex(checkBoxItem => checkBoxItem.propertyDisplayName === chipToRemove.labelDisplayName);
            if (index !== -1) {
                data.checkBoxSelectionArray.splice(index, 1);
            }
        }
        dispatch({ path: 'data', value: { ...data } });
        return [..._.pullAllBy(chipArray, [{ labelDisplayName: chipToRemove.labelDisplayName }], 'labelDisplayName')];
    }
    return chipArray;
}

export const dummyFunction = () => {
    console.log('event Sub');
}
